import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/add_attribute.scss';
import { trim } from '../Reusables/Function';

import closeIcon from '../../images/popups/upload/closeicon.png';

function AddAttribute(props) {
    const {show, handleClose, getAttributeDetails, attributeerror, attributetoggle, setEnableAttribute, enableAttribute} = props;
    const [attributeDetails, setAttributeDetails] = useState({AttributeName: null, Value: null});

    const handleAttribute = (attribute) => {
        setAttributeDetails({
            ...attributeDetails,
            AttributeName: trim(attribute)
        })
    }

    const handleValue = (value) => {
        setAttributeDetails({
            ...attributeDetails,
            Value: trim(value)
        })
    }

    const handleSave = () => {
        setEnableAttribute(false);
        getAttributeDetails(attributeDetails);
    }

    useEffect(()=> {
        setAttributeDetails({
            AttributeName: null,
            Value: null,
        })
    }, [attributetoggle])

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='add-attribute-popup'
                centered>
                <Modal.Body className='add-attribute-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='add-attribute-popup-header'>Add Additional Attributes</div>
                    <div className='add-attribute-popup-body'>
                        <div className='error-message'>{attributeerror}</div>
                        <div className='name-container'>
                            <label className='required'>Name</label>
                            <div><input type="text" onChange={(e) => handleAttribute(e.target.value)}/></div>
                        </div>
                        <div className='value-container'>
                            <label className='required'>Value</label>
                            <div><input type="text" onChange={(e) => handleValue(e.target.value)}/></div>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button disabled={enableAttribute ? false : true} className={enableAttribute ? 'enable' : 'disable'} onClick={handleSave}>Add</button>
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddAttribute;